import classNames from 'classnames';
import React, { Component } from 'react';

import { secondsToVideoTS } from 'utilities/time';

import './styles.less';

class TimeDisplay extends Component {
  render() {
    const { currentTime, className = '', duration } = this.props;

    return (
      <div className={classNames('video-player-time-display', className)}>
        <span>{secondsToVideoTS(Math.round(currentTime))}</span>
        <span className="divider">/</span>
        <span>{secondsToVideoTS(Math.round(duration))}</span>
      </div>
    );
  }
}

export default TimeDisplay;
